import React, { useContext, useState, } from 'react';
import { Card } from 'reactstrap';
import { useHistory } from "react-router-dom";
import Filters from '../components/filters/Filters';
import ListComponent from '../components/ListComponent';
import ConfirmRejectionDialog from 'views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ConfirmRejectionDialog';
import ApprovalSentSuccessDialog from 'views/pages/manage/unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog';
import ALoader from 'views/pages/manage/common/a-loader';
import { PermissionContext } from 'appContext';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { useApprovalListing } from '../shared/hooks';
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { UserDetails } from 'appContext';
import DocumentViewer from '../../cash-management/receipt/components/DocumentViewerModal';
import { approvalConfig } from '../shared/config';
import ChequeDateExtensionLogs from '../components/actions/ChequeDateExtensionLogs';

const ApprovalListingWrapper = ({ userPermissions, type, heading }) => {
  const permissions = useContext(PermissionContext);
  const userDetails = useContext(UserDetails);
  const isApproverPermission = checkPermission(userPermissions, "A");
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const {
    dropdownData,
    approvalRequests,
    globalFilter,
    paginationInfo,
    approvalActionSuccessDialogInfo,
    updateStatusInfo,
    onViewSlip,
    // loading,
    viewer,
    showModelInfo,

    setViewer,
    // setLoading,
    setGlobalFilter,
    setUpdateStatusInfo,
    setApprovalActionSuccessDialogInfo,
    setShowModelInfo,

    getApprovalRequests,
    updateStatus,
    getChequeDateExtensionLogs,

  } = useApprovalListing({permissions,type, setLoading});

  return (
    <>
      {loading && <ALoader position="fixed" />}

      <Card className="m-3 px-2 pt-3">
        <div className="d-flex justify-content-between">
          <div>
            <BackArrow className="mr-2 cursor" onClick={() => history.goBack()} />
            <h3 className="d-inline"> {heading}</h3>
          </div>

          <Filters
            dropdowns={dropdownData}
            getApprovalRequests={getApprovalRequests}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            searchInputOptions={approvalConfig[type]?.outerInputSearchFilter}
            type={type}
          />
        </div>

        <ListComponent
          rows={approvalRequests}
          setUpdateStatusInfo={setUpdateStatusInfo}
          updateStatus={updateStatus}
          paginationInfo={paginationInfo}
          setLoader={setLoading}
          getApprovalRequests={getApprovalRequests}
          isApprovePermission={isApproverPermission}
          dropdowns={dropdownData}
          userDetails={userDetails}
          onViewSlip={onViewSlip}
          type={type}
          showModelInfo={showModelInfo}
          getChequeDateExtensionLogs={getChequeDateExtensionLogs}
          setShowModelInfo={setShowModelInfo}
        />
      </Card>

      <ConfirmRejectionDialog
        updateStatusInfo={updateStatusInfo}
        setUpdateStatusInfo={setUpdateStatusInfo}
        updateStatus={updateStatus}
        dialogInfo={updateStatusInfo?.dialogInfo}
        customStyle={{ maxWidth: '424px' }}
      />

      <ApprovalSentSuccessDialog
        open={approvalActionSuccessDialogInfo}
        setOpen={setApprovalActionSuccessDialogInfo}
        heading={approvalActionSuccessDialogInfo?.heading}
        subHeading={approvalActionSuccessDialogInfo?.subHeading}
        closeCb={() => getApprovalRequests({})}
      />
      <DocumentViewer
        open={viewer.open}
        onClose={() => setViewer({ open: false, s3key: "" })}
        s3Key={viewer.s3key}
      />
      <ChequeDateExtensionLogs
        getChequeDateExtensionLogs={getChequeDateExtensionLogs}
        setShowModelInfo={setShowModelInfo}
        showModelInfo={showModelInfo}
      />
    </>
  );
};

export default ApprovalListingWrapper;
